import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class MedicineReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      medicine: "NA",
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/medicine/getHistory",
        this.props.data
      )
      .then(response => {
        this.setState({
          medicine: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  tabRow() {
    if (this.state.medicine !== "NA")
      return this.state.medicine.map(function (obj) {
        if (
          obj.txnDate !== null &&
          obj.txnDate !== "" &&
          obj.txnDate !== undefined
        ) {
          var arrDate = obj.txnDate.split("-");
          var txndate =
            arrDate[2].substring(0, 2) + "-" + arrDate[1] + "-" + arrDate[0];
        }

        var open =
          obj.openingMain +
          " / " +
          obj.openingSub +
          " / " +
          obj.openingAKit +
          " / " +
          obj.openingBKit;
        var close =
          obj.closingMain +
          " / " +
          obj.closingSub +
          " / " +
          obj.closingAKit +
          " / " +
          obj.closingBKit;
        var patient = "";
        if (obj.pno !== "") patient = "[" + obj.pno + "] " + obj.patientName;
        return (
          <tr key={obj._id}>
            <td className="border p-1">{txndate}</td>
            <td className="border p-1 ">{obj.txnType}</td>
            <td className="border p-1 text-wrap">{obj.desc}</td>
            <td className="border p-1 ">{open}</td>
            <td className="border p-1">{obj.qty}</td>
            <td className="border p-1 ">{close}</td>
            <td className="border p-1 ">{patient}</td>
          </tr>
        );
      });
  }

  GetMedicineName() {
    if (this.state.medicine !== "NA" && this.state.medicine.length > 0)
      return this.state.medicine[0].medName;
    else
      return "";
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Medicine Tracker</h3>
        <h5 align="center">Medicine : {this.GetMedicineName()}</h5>
        <div>* Stock Format [Main / Sub / A Kit / B Kit]</div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>
                <tr>
                  <th className="border p-1 font-weight-bold" width="150px">
                    Date
                  </th>
                  <th className="border p-1 font-weight-bold" width="120px">
                    Type
                  </th>
                  <th className="border p-1 font-weight-bold" width="180px">
                    Description
                  </th>
                  <th className="border p-1 font-weight-bold" width="200px">
                    Opening Stock *
                  </th>
                  <th className="border p-1 font-weight-bold" width="100px">
                    Quantity
                  </th>
                  <th className="border p-1 font-weight-bold" width="200px">
                    Closing Stock *
                  </th>
                  <th className="border p-1 font-weight-bold" width="200px">
                    Patient
                  </th>
                </tr>
              </thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default MedicineReport;
